import axios, { AxiosResponse } from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';
import { ContentTypePoolWorkoutDtoType } from 'types/services/magnolia/dtos/ContentTypePoolWorkoutDto';
import { PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';

const NO_CACHE_POOLS: string[] = ['recipe'];

export type PoolsAPIFetchPoolResponse = {
	items: ContentTypePoolWorkoutDtoType[];
};

export const fetchPool = (
	selectedPool: PoolEnumType,
	dedicatedPoolForItemId?: string
): Promise<AxiosResponse<PoolsAPIFetchPoolResponse>> => {
	const dedicatedURLPart = dedicatedPoolForItemId ? `/${dedicatedPoolForItemId}` : '';
	let requestURL = `${appConfig.env.urlMagnoliaAPICoach}/pool/${selectedPool}${dedicatedURLPart}.json`;

	if (!!~NO_CACHE_POOLS.indexOf(selectedPool)) {
		requestURL += '?secure';
	}

	return axios.get(requestURL, {
		withCredentials: false,
		headers: {
			Accept: 'application/json',
		},
	});
};

export type PoolsAPIFetchPoolItemResponse = {
	externalId: string;
};

export const fetchPoolItem = <T>(query: string): Promise<AxiosResponse<PoolsAPIFetchPoolItemResponse & T>> => {
	const requestUrl = `${appConfig.env.urlMagnoliaAPICoach}/contenttypes/${query}.json`;

	return axios.get(requestUrl, {
		withCredentials: false,
	});
};
